import { Pagination } from 'antd';
import Styles from './assets/style.scss';
import { IPagination } from './entities';

const BCAntPagination = (props: IPagination) => {
	Styles;
	return <Pagination {...props} />;
};

export default BCAntPagination;
export { IPagination };
